// extracted by css-extract-rspack-plugin
export default {"wordWrapButtonIcon":"wordWrapButtonIcon_SMj9","wordWrapButtonEnabled":"wordWrapButtonEnabled_vR9E"};